import { request } from 'src/api/request';

export const getEducationSuggestions = async ({ queryParams }) => {
  return await request({
    url: `v1/entities/educational-institutions/${queryParams}`,
    method: 'GET',
  });
};

export const getGPOSuggestions = async ({ queryParams }) => {
  return await request({
    url: `v1/entities/gpos/${queryParams}`,
    method: 'GET',
  });
};

export const getOpenPaymentsSuggestions = async ({ queryParams }) => {
  return await request({
    url: `v1/entities/open-payments-companies/${queryParams}`,
    method: 'GET',
  });
};

export const getListSuggestions = async ({ queryParams }) => {
  return await request({
    url: `v1/provider-lists/lists/${queryParams}`,
    method: 'GET',
  });
};

export const getHospitalSystemSuggestions = async ({ queryParams }) => {
  return await request({
    url: `v1/entities/systems/${queryParams}`,
    method: 'GET',
  });
};

export const getPlaceOfServiceSuggestions = async ({ queryParams }) => {
  return await request({
    url: `v1/entities/places-of-service/${queryParams}`,
    method: 'GET',
  });
};

export const getCRMOwnerSuggestions = async ({ queryParams }) => {
  return await request({
    url: `v1/integrations/crm-links/owners/${queryParams}`,
    method: 'GET',
  });
};

export const getCRMStatusSuggestions = async ({ queryParams }) => {
  return await request({
    url: `v1/integrations/crm-links/distinct-statuses/${queryParams}`,
    method: 'GET',
  });
};

export const getSpecialtySuggestions = async ({ queryParams }) => {
  return await request({
    url: `v1/entities/specialties/${queryParams}`,
    method: 'GET',
  });
};

export const getTagSuggestions = async ({ queryParams }) => {
  return await request({
    url: `v1/accounts/tags/${queryParams}`,
    method: 'GET',
  });
};

export const getCodeSuggestions = async ({ queryParams }) => {
  return await request({
    url: `v1/search/codes/${queryParams}`,
    method: 'GET',
  });
};
